if (!customElements.get('view-toggler')) {
  customElements.define(
    'view-toggler',
    class ViewToggler extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('.js-view-form');
        this.savedColumns = localStorage.getItem('grid_columns') || '2';
        this.onChange = this.onChange.bind(this);
        this.gridEl = document.getElementById('product-grid');
      }

      connectedCallback() {
        if (!this.form || !this.gridEl) return;
        this.loadSettings();
        this.form.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.form.removeEventListener('change', this.onChange);
      }

      updateGridClass() {
        // prevents loss of element during section rendering
        this.gridEl = document.getElementById('product-grid');

        const currentClass = this.gridEl.classList.value.match(/grid--\d+-col/);
        if (currentClass) {
          const newClass = `grid--${this.savedColumns}-col`;
          this.gridEl.classList.replace(currentClass[0], newClass); 
        }
      }

      loadSettings() {
        this.updateGridClass();
        const radio = this.form.querySelector(`input[value="${this.savedColumns}"]`);
        if (radio) radio.checked = true;
        this.classList.remove('idle')
      }

      onChange(event) {
        if (event.target.name === 'grid-columns') {
          this.savedColumns = event.target.value;
          localStorage.setItem('grid_columns', this.savedColumns);
          this.updateGridClass();
        }
      }
    }
  );
}
